import React, { forwardRef } from "react"

const HelpIcon = forwardRef<SVGSVGElement>((props, ref) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
      ref={ref}
    >
      <path
        d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
        stroke="#2F3B5A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.08984 9.50008C9.32495 8.83175 9.789 8.26819 10.3998 7.90921C11.0106 7.55024 11.7287 7.41902 12.427 7.53879C13.1253 7.65857 13.7587 8.02161 14.2149 8.56361C14.6712 9.10561 14.9209 9.7916 14.9198 10.5001C14.9198 12.5001 11.9198 13.5001 11.9198 13.5001"
        stroke="#2F3B5A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.5H12.0109"
        stroke="#2F3B5A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default HelpIcon
